(() => {
  'use strict';
  if (window.lipovitaLandingInitialized) return;
  window.lipovitaLandingInitialized = true;
  const controllers = new WeakMap();

  function init(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    const { signal } = controller;
    const product = root.dataset.lpProduct;
    if (product === 'optislim' || product === 'lipovita') {
      const languages = new Set(['en', 'da', 'de', 'es', 'fi', 'fr', 'it', 'nl', 'sv']);
      const languageDestination = language => {
        const url = new URL(language === 'en'
          ? `https://${product}.swissnutri.com/`
          : `https://${product}.swissnutri.com/${language}`);
        new URL(window.location.href).searchParams.forEach((value, name) => {
          if (/^utm_/i.test(name) || ['gclid', 'fbclid', 'msclkid'].includes(name)) url.searchParams.set(name, value);
        });
        return url.toString();
      };
      const updateLanguageLinks = () => {
        document.querySelectorAll('.ly-languages-switcher-link[data-language-code]').forEach(link => {
          const language = link.dataset.languageCode;
          if (!languages.has(language)) return;
          link.href = languageDestination(language);
          link.hreflang = language;
          link.dataset.lpTranslationLink = language;
        });
      };
      updateLanguageLinks();
      const languageObserver = new MutationObserver(updateLanguageLinks);
      languageObserver.observe(document.body, { childList: true, subtree: true });
      signal.addEventListener('abort', () => languageObserver.disconnect(), { once: true });
      document.addEventListener('click', event => {
        const link = event.target.closest('.ly-languages-switcher-link[data-lp-translation-link]');
        if (!link || !languages.has(link.dataset.lpTranslationLink)) return;
        // Keep Langify's dropdown UI, but navigate to the same product's translation.
        event.stopImmediatePropagation();
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        window.location.assign(languageDestination(link.dataset.lpTranslationLink));
      }, { capture: true, signal });
    }
    const stringsNode = root.querySelector('[data-lp-strings]');
    const strings = stringsNode ? JSON.parse(stringsNode.textContent) : {};
    const copy = (key, fallback, values = {}) => {
      let text = strings[key] || fallback;
      Object.entries(values).forEach(([name, value]) => { text = text.replaceAll(`__${name}__`, String(value)); });
      return text;
    };
    const quiz = root.querySelector('[data-lp-quiz]');
    const form = quiz.querySelector('[data-lp-quiz-form]');
    const steps = [...form.querySelectorAll('[data-lp-step]')];
    const next = form.querySelector('[data-lp-next]');
    const back = form.querySelector('[data-lp-back]');
    const questions = quiz.querySelector('[data-lp-questions]');
    const result = quiz.querySelector('[data-lp-result]');
    const resultLink = quiz.querySelector('[data-lp-result-link]');
    let index = 0;

    function revealQuizOnMobile() {
      if (window.matchMedia('(max-width: 767px)').matches) quiz.scrollIntoView({ block: 'start' });
    }

    function showStep(focus = false) {
      steps.forEach((step, i) => { step.hidden = i !== index; });
      quiz.querySelector('[data-lp-step-label]').textContent = copy('progress', `Question ${index + 1} of ${steps.length}`, { current: index + 1, total: steps.length });
      quiz.querySelector('[data-lp-progress]').value = index + 1;
      next.disabled = !steps[index].querySelector('input:checked');
      next.querySelector('span').textContent = index === steps.length - 1 ? copy('see_options', 'See my options') : copy('continue', 'Continue');
      back.hidden = index === 0;
      if (focus) {
        steps[index].querySelector('input').focus({ preventScroll: true });
        revealQuizOnMobile();
      }
    }

    form.addEventListener('change', () => showStep(), { signal });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (next.disabled) return;
      if (index < steps.length - 1) {
        index += 1;
        showStep(true);
        return;
      }
      const choices = new FormData(form);
      const count = choices.get('pack');
      const destination = choices.get('next');
      let highlighted = false;
      root.querySelectorAll('[data-lp-pack]').forEach(pack => {
        if (pack.dataset.lpPack === count) {
          pack.dataset.lpRecommended = 'true';
          highlighted = true;
        }
        else delete pack.dataset.lpRecommended;
      });
      let text = count === 'compare' || !highlighted
        ? copy('compare_all', 'Compare all the pack sizes below, with the total price and price per bottle clearly shown.')
        : copy(count === '1' ? 'chosen_single' : 'chosen_multiple', `You chose ${count === '1' ? 'a one-bottle' : `a ${count}-bottle`} pack. We have highlighted that option so you can check its current price and availability.`, { count });
      let target = root.querySelector('.lp-offers');
      let label = copy('pack_link', 'See my pack options');
      if (destination === 'ingredients') {
        text += ` ${copy('ingredient_text', 'Start with the ingredient overview, then compare the packs whenever you are ready.')}`;
        target = root.querySelector('.lp-ingredients');
        label = copy('ingredient_link', 'Explore the ingredients');
      } else if (destination === 'faq') {
        text += ` ${copy('faq_text', 'Start with answers to common questions before choosing your pack.')}`;
        target = root.querySelector('.lp-faq');
        label = copy('faq_link', 'Read the FAQs');
      }
      quiz.querySelector('[data-lp-result-text]').textContent = text;
      resultLink.href = `#${target.id}`;
      // Keep the theme's arrow icon separate from the editable button label.
      resultLink.firstChild.textContent = `${label} `;
      questions.hidden = true;
      result.hidden = false;
      result.focus({ preventScroll: true });
      revealQuizOnMobile();
    }, { signal });

    back.addEventListener('click', () => {
      if (index > 0) index -= 1;
      showStep(true);
    }, { signal });
    quiz.querySelector('[data-lp-restart]').addEventListener('click', () => {
      form.reset();
      index = 0;
      result.hidden = true;
      questions.hidden = false;
      root.querySelectorAll('[data-lp-recommended]').forEach(pack => delete pack.dataset.lpRecommended);
      showStep(true);
    }, { signal });
    showStep();

    root.querySelectorAll('[data-lp-product-form]').forEach(productForm => {
      productForm.addEventListener('submit', async (event) => {
        if (!window.fetch) return; // Normal Shopify form submission remains the fallback.
        event.preventDefault();
        const button = productForm.querySelector('[data-lp-add]');
        if (button.disabled) return;
        const original = button.innerHTML;
        const status = productForm.querySelector('[data-lp-cart-status]');
        button.disabled = true;
        button.textContent = copy('adding', 'Adding to your cart…');
        status.textContent = '';
        try {
          const body = new FormData(productForm);
          body.delete('return_to');
          const response = await fetch(`${productForm.action}.js`, {
            method: 'POST', body, headers: { Accept: 'application/json' }, signal
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : copy('add_error', 'This pack could not be added. Please try again.'));
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          if (error.name === 'AbortError') return;
          status.textContent = error.message || copy('try_again', 'Please try again or open the product details below.');
          button.disabled = false;
          button.innerHTML = original;
        }
      }, { signal });
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-lp-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-lp-root]').forEach(root => {
      controllers.get(root)?.abort();
      controllers.delete(root);
    });
  });
})();
